var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProductOutOfStock = function SvgProductOutOfStock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    clipPath: "url(#product-out-of-stock_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M4 1.333 2 4v9.333a1.333 1.333 0 0 0 1.333 1.333h9.334A1.333 1.333 0 0 0 14 13.333V4l-2-2.667zM2 4h12"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10.667 6.667a2.667 2.667 0 1 1-5.333 0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "M16 2.667 2.667 16"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeWidth: 1.5,
    d: "M15.334 2 2.001 15.333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "product-out-of-stock_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgProductOutOfStock;